import { render } from "./App.vue?vue&type=template&id=17883cd3&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17883cd3&scoped=true&lang=less"
import "./App.vue?vue&type=style&index=1&id=17883cd3&lang=less"
script.render = render
script.__scopeId = "data-v-17883cd3"

export default script